import { MiddotSeparated } from "@indietabletop/appkit";
import type { ReactNode } from "react";
import type { GitProfile } from "../../engine/Ruleset.ts";
import { caps, diceRolls, list } from "../fmt.ts";
import { type FormOptionProps, FormOption } from "../forms/FormTextField.tsx";
import { formOption } from "../GangPage/style.css.ts";
import { useGangContext } from "../GangPage/useGang.ts";

export function GitTypeFormOption(
  props: Pick<FormOptionProps, "name" | "type"> & {
    profile: GitProfile;
    counter?: ReactNode;
    priceMultiplier?: number;
  },
) {
  const { profile, counter, priceMultiplier = 1, ...optionProps } = props;
  const { gang } = useGangContext();

  const rules =
    profile.rules?.map((ref) => gang.ruleset.gitSpecialRules.get(ref.id)) ?? [];

  return (
    <FormOption
      {...optionProps}
      value={profile.id}
      label={profile.name}
      info={caps(profile.cost * priceMultiplier)}
      description={
        <>
          <MiddotSeparated>
            <span>Scoot: {diceRolls(profile.scoot)}</span>
            <span>Headbutt: {profile.headbutt}</span>
            <span>Toughness: {profile.toughness}</span>
          </MiddotSeparated>

          {rules.length > 0 && <div>Special: {list(rules)}</div>}

          {counter && <div className={formOption.extras}>{counter}</div>}
        </>
      }
    />
  );
}
